module.exports = __webpack_public_path__ + "img/4.0bc68d9b.png";